import { createContext, startTransition, useContext, useState } from "react";
import { Button } from "../Button";
import { cn } from "../cn";

export const TabsContext = createContext<{
  activeTab: string;
  setActiveTab: (tab: string) => void;
}>({
  activeTab: '',
  setActiveTab: () => {},
});

export const TabsItem = ({tab, children}: React.PropsWithChildren<{
  tab: string,
}>) => {
  const { activeTab } = useContext(TabsContext);
  const isActive = activeTab === tab;
  if(isActive) return children;
  return null;
}

export const Tabs = ({defaultTab, tabs, children}: React.PropsWithChildren<{
  defaultTab: string,
  tabs: string[],
}>) => {
  const [activeTab, setActiveTab] = useState<string>(defaultTab);
  return (
    <TabsContext.Provider value={{
      activeTab,
      setActiveTab,
    }}>
      <div className='flex flex-row gap-2.5 lg:gap-5 pb-2.5 lg:pb-5'>
        {tabs.map((x) => (
          <Button unstyled
            children={x}
            key={x}
            onPress={() => startTransition(() => setActiveTab(x))}
            className={cn(
              'border-b-2 border-neutral-200 pb-0.5 sm:pb-1.5 px-3 text-text text-md sm:text-lg leading-7 font-bold',
              activeTab === x && 'border-accent',
            )}
          />
        ))}
      </div>
      <div className=''>
        {children}
      </div>
    </TabsContext.Provider>
  )
}